export type AuthModalAction =
  | { type: "none" }
  | { type: "open-modal" }
  | { type: "disconnect" }
  | { type: "goto"; path: string };

export type ResolveAuthModalActionParams = {
  /** The `email` query param: the auth-intent signal carried by email links. */
  email: string | null | undefined;
  /** True only for a Better Auth session; a guest session never counts. */
  hasSession: boolean;
  userEmail: string | null | undefined;
  goto: string | null | undefined;
  alreadyDisconnectedForEmail: boolean;
};

export const resolveAuthModalAction = ({
  email,
  hasSession,
  userEmail,
  goto,
  alreadyDisconnectedForEmail,
}: ResolveAuthModalActionParams): AuthModalAction => {
  if (!email) {
    return { type: "none" };
  }
  if (!hasSession) {
    return { type: "open-modal" };
  }
  if (userEmail !== email) {
    // Sign out once per target email: if the session survives (cookie not
    // cleared), fall through to the modal instead of looping on sign-out.
    return alreadyDisconnectedForEmail
      ? { type: "open-modal" }
      : { type: "disconnect" };
  }
  if (goto) {
    return { type: "goto", path: goto };
  }
  return { type: "none" };
};
